import styled, { css } from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  min-width: 320px;
  margin: 0 auto;
  padding: 10px 0;
`

const Header = styled.h4`
  && {
    margin-bottom: 0;
  }

  ${props =>
    css`
      @media only screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        display: flex;
        flex: 1 0 auto;
        align-items: center;
        justify-content: space-between;
      }
    `}
`

const Name = styled.span`
  ${props =>
    css`
      @media only screen and (max-width: ${props.theme.size.breakpoint['max-width'].sm}) {
        display: none;
      }
    `}
`

const Price = styled.span`
  text-align: right;
  font-size: 1.5em;
  margin-left: 10px;

  ${props =>
    css`
      @media only screen and (max-width: ${props.theme.size.breakpoint['max-width'].xs}) {
        font-size: 2em;
      }
    `}
`

const ATTContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 0px 10px;
  width: 100%;
  border-left: 1px solid ${props => props.theme.color.monochrome.light};

  ${props =>
    css`
      @media only screen and (max-width: ${props.theme.size.breakpoint['max-width'].xs}) {
        border-left: none;
      }
    `}
`

const QuantityContainer = styled.div`
  width: 100%;
  max-width: 80px;
  margin: 0px 15px;

  ${props =>
    css`
      @media only screen and (max-width: ${props.theme.size.breakpoint['max-width'].xs}) {
        display: none;
      }
    `}
`

const ATTButtonContainer = styled.div`
  width: 100%;
  margin: 0px 10px;
`

export { Container, Header, Name, Price, ATTContainer, QuantityContainer, ATTButtonContainer }
